module.exports = __webpack_public_path__ + "files/tartrais.9685bd45c384c66bc54dc590cbddff1f.pdf";